import React from 'react';
import { Ornament } from './Ornament';
import { opportunity } from '../data/content';
export function SolutionSection() {
  return <section className="bg-cream text-ink" data-id="element-189" data-mp="3aaub3dpcj7ed">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:px-6 lg:py-24" data-id="element-190" data-mp="3o9albemf3g19">
        <Ornament data-id="element-191" data-mp="3o77mq6778ekx" />
        <h2 className="mt-6 font-display text-[1.9rem] font-semibold leading-[1.15] text-brown sm:text-[2.6rem]" data-id="element-192" data-mp="3ja7gnvacnbtt">
          {opportunity.quote}{' '}
          <span className="text-rose-deep" data-id="element-193" data-mp="131ghc4dight">{opportunity.quoteAccent}</span>
        </h2>

        <div className="mx-auto mt-7 max-w-xl space-y-4 font-sans text-[0.98rem] leading-relaxed text-ink-soft sm:text-[1.05rem]" data-id="element-194" data-mp="3t7bzbl4zkp5v">
          {opportunity.body.map(paragraph => <p key={paragraph} data-id="element-195" data-mp="5vkvmdipljoq">{paragraph}</p>)}
        </div>

        <div className="mx-auto mt-12 max-w-xl rounded-[28px] bg-white px-6 py-9 shadow-[0_20px_50px_-30px_rgba(104,69,54,0.45)] ring-1 ring-gold/25 sm:px-10" data-id="element-196" data-mp="5w2vrl8hsi1x">
          <p className="font-sans text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-gold-deep" data-id="element-197" data-mp="fujskyu43qvw">
            Por eso nació
          </p>
          <p className="mt-3 font-display text-[1.35rem] font-semibold uppercase leading-tight tracking-[0.08em] text-brown sm:text-2xl" data-id="element-198" data-mp="36cox8fcsv7cw">
            Desafío <span className="font-script text-[2.1rem] normal-case tracking-normal text-rose sm:text-[2.5rem]" data-id="element-199" data-mp="3fb0xl93gxjij">Mujer de</span>{' '}
            Proverbios 31
          </p>
          <div className="mx-auto mt-6 max-w-sm space-y-1.5 font-sans text-[0.95rem] leading-relaxed text-ink-soft" data-id="element-200" data-mp="3p9ht8jdcqmax">
            {opportunity.closing.map((line, index) => <p key={line} className={index === opportunity.closing.length - 1 ? 'pt-2 font-display text-xl font-semibold italic text-rose-deep' : ''} data-id="element-201" data-mp="3u70269rdd1ix" data-mpi={index}>
                {line}
              </p>)}
          </div>
        </div>
      </div>
    </section>;
}